export default "__VITE_ASSET__D3ga39J8__"